(function () {
  'use strict';
  if (window.MedLinksStock) return;
  var approvedForms = new WeakSet();
  var pendingForms = new WeakSet();
  var cartQuantities = null;

  function inputFor(form) {
    return form && document.querySelector('.ml-quantity-control__input[form="' + CSS.escape(form.getAttribute('id')) + '"]');
  }

  function message(input, text) {
    var control = input.closest('[data-ml-quantity-control]');
    var note = control.parentElement.querySelector('[data-ml-stock-message]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'ml-stock-message';
      note.dataset.mlStockMessage = '';
      note.setAttribute('role', 'status');
      control.parentElement.appendChild(note);
    }
    note.textContent = text;
    note.hidden = !text;
  }

  function limitFor(input) {
    var rule = input.dataset.mlRuleMax === '' ? Infinity : Number(input.dataset.mlRuleMax);
    var inCart = cartQuantities ? (cartQuantities[input.dataset.mlVariantId] || 0) : Number(input.dataset.mlCartQuantity || 0);
    var stock = input.dataset.mlStockLimit === '' ? Infinity : Number(input.dataset.mlStockLimit);
    return Math.max(0, Math.min(rule, stock) - inCart);
  }

  function sync(input) {
    var limit = limitFor(input);
    var min = Number(input.min) || 1;
    var step = Number(input.step) || 1;
    var max = limit < min ? 0 : min + Math.floor((limit - min) / step) * step;
    if (Number.isFinite(max)) input.max = String(max);
    else input.removeAttribute('max');
    var value = Number(input.value);
    if (!Number.isFinite(value) || value < min) value = min;
    value = min + Math.floor((value - min) / step) * step;
    if (max >= min) value = Math.min(value, max);
    if (input.value !== String(value)) input.value = String(value);
    var control = input.closest('[data-ml-quantity-control]');
    control.querySelectorAll('[data-ml-quantity-current]').forEach(function (node) {
      if (node.textContent !== String(value)) node.textContent = String(value);
    });
    control.querySelectorAll('[data-ml-quantity-step]').forEach(function (button) {
      var next = value + Number(button.dataset.mlQuantityStep) * step;
      button.disabled = max < min || next < min || next > max;
    });
    var form = document.getElementById(input.getAttribute('form'));
    if (form) Array.from(form.elements).concat(Array.from(document.querySelectorAll('[data-ml-buy-now][data-form-id="' + CSS.escape(form.getAttribute('id')) + '"]'))).forEach(function (button) {
      if (button.type !== 'submit' && !button.matches('[data-ml-buy-now]')) return;
      if (max < min && !button.disabled) {
        button.disabled = true;
        button.dataset.mlStockDisabled = 'true';
      } else if (max >= min && button.dataset.mlStockDisabled === 'true') {
        button.disabled = false;
        delete button.dataset.mlStockDisabled;
      }
    });
    if (max < min) message(input, control.dataset.mlStockExhausted);
    else message(input, '');
    return max;
  }

  function syncAll() {
    document.querySelectorAll('.ml-quantity-control__input[data-ml-stock-limit]').forEach(sync);
  }

  function useCart(cart) {
    cartQuantities = {};
    cart.items.forEach(function (item) {
      var id = String(item.variant_id);
      cartQuantities[id] = (cartQuantities[id] || 0) + item.quantity;
    });
    syncAll();
  }

  async function validate(form) {
    var input = inputFor(form);
    if (!input) return true;
    if (pendingForms.has(form)) return false;
    pendingForms.add(form);
    var requested = Number(input.value);
    try {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('cart');
      useCart(await response.json());
      if (inputFor(form) !== input || !input.isConnected) {
        pendingForms.delete(form);
        return false;
      }
      var max = sync(input);
      var min = Number(input.min) || 1;
      var step = Number(input.step) || 1;
      if (!Number.isInteger(requested) || requested < min || requested > max || (requested - min) % step !== 0) {
        if (max >= min) message(input, input.closest('[data-ml-quantity-control]').dataset.mlStockRemaining.replace('__MAX__', String(max)));
        pendingForms.delete(form);
        return false;
      }
      return true;
    } catch (error) {
      pendingForms.delete(form);
      message(input, input.closest('[data-ml-quantity-control]').dataset.mlStockError);
      return false;
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!inputFor(form)) return;
    if (approvedForms.has(form)) {
      approvedForms.delete(form);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    validate(form).then(function (valid) {
      if (!valid) return;
      if (!form.checkValidity()) { pendingForms.delete(form); form.reportValidity(); return; }
      approvedForms.add(form);
      form.requestSubmit();
    });
  }, true);

  ['input', 'change'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (event.target.matches('.ml-quantity-control__input[data-ml-stock-limit]')) sync(event.target);
    });
  });
  ['variant:added', 'cart-notification:show'].forEach(function (name) {
    document.addEventListener(name, function () { pendingForms = new WeakSet(); });
  });
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) useCart(event.detail.cart);
  });
  document.addEventListener('cart:refresh', function (event) {
    if (event.detail && event.detail.cart) useCart(event.detail.cart);
  });
  document.addEventListener('DOMContentLoaded', syncAll);
  new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) { return Array.from(mutation.addedNodes).some(function (node) { return node.nodeType === 1; }); })) syncAll();
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.MedLinksStock = { validate: validate, release: function (form) { pendingForms.delete(form); } };
  syncAll();
})();
